import React, { useState } from "react";
import NavigationDrawer from "./../../../components/NavigationDrawer/index";
import { useDispatch, useSelector } from "react-redux";
import { setActiveTab } from "../../../lib/slices/activeTabSlice";
import { Grid } from "@mui/material";
import DynamicTabsDrawer from "../../../components/DynamicTabDrawer";
import Profile from "./Profile";
import AllRolls from "./AllRolls";
import AllUsers from "./AllUsers";
import Loader from "../../../components/Loader";

const tabs = [
  // { label: "Personal Details", value: "personal" },
  { label: "Create Roles", value: "roles" },
  { label: "Create Users", value: "users" },
];

function ClientSettings() {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  console.log(isLoading, "isLoadingisLoadingisLoading");

  // Redux states
  const activeTab = useSelector((state) => state.activeTab.tabs);

  // Function

  const handleChangeTab = (tab) => {
    dispatch(setActiveTab({ ...activeTab, admin_setting: tab }));
  };

  return (
    <NavigationDrawer>
      <Grid container spacing={1}>
        <Grid item xs={12} md={2.3}>
          <DynamicTabsDrawer
            primaryHeading={"Settings*"}
            tabs={tabs}
            activeTab={activeTab.admin_setting}
            handleChangeTab={handleChangeTab}
          />
        </Grid>
        <Grid item xs={12} md={9.7}>
          {activeTab.admin_setting === "users" ? (
            <AllUsers setIsLoading={setIsLoading} />
          ) : (
            <AllRolls setIsLoading={setIsLoading} />
          )}
        </Grid>
      </Grid>
      <Loader isLoading={isLoading} />
    </NavigationDrawer>
  );
}

export default ClientSettings;
